import React,{useState,useEffect} from 'react'
import '../../../../css/Settings/CompanySettings/companySettings.css'
import {Typography} from '@mui/material'
import {ProfileInfo} from '../CompanySettings/ProfileInfo'
import {AccountSettings} from '../CompanySettings/AccountSettings'
import {GstAndTax} from '../CompanySettings/GstAndTax'
import {ForgotPassword} from '../CompanySettings/ForgotPassword'
import { viewCompanyProfileInfoAPICall } from '../../../../API/Settings/Company Settings/companySettingsAPI'
import { useSelector } from 'react-redux'
export const CompanySettings = () => {
    const [activeTab, setActiveTab] = useState("profileInfo");

    //*Redux States
    //Company Profile Data
    const companyProfileData = useSelector(
    (state) => state.companyProfileSlice.value
    );

    const [isModify,setIsModify]=useState(false)
    let currentCountry=localStorage.getItem('country');
    useEffect(() => {
      currentCountry=localStorage.getItem('country');
    }, []);

    //Update Listener
    const updateListener=()=>{
      setIsModify(!isModify)
    }




    //* API Calls
    useEffect(() => {
      viewCompanyProfileInfoAPICall();
    }, [isModify]);




    const profileInfoMenuClick = () => {
        document.getElementById("profileInfoBtn").classList.add("active");
        document.getElementById("accountSettingsBtn").classList.remove("active");
        document.getElementById("gstAndTaxBtn").classList.remove("active");
        setActiveTab("profileInfo");
      };
      const accountSettingsMenuClick = () => {
        document.getElementById("profileInfoBtn").classList.remove("active");
        document.getElementById("accountSettingsBtn").classList.add("active");
        document.getElementById("gstAndTaxBtn").classList.remove("active");
    
        setActiveTab("accountSettings");
      };
      const gstAndTaxMenuClick = () => {
        document.getElementById("profileInfoBtn").classList.remove("active");
        document.getElementById("accountSettingsBtn").classList.remove("active");
        document.getElementById("gstAndTaxBtn").classList.add("active");
    
        setActiveTab("gstAndTax");
      };

  return (
    <div className="company-settings-container">
       <div className="company-settings-tab-container">
         <div className="company-settings-tab-menu-container">
           <div className="company-settings-tab-menus-container">
           <div
                className="tab-menu-button active"
                id="profileInfoBtn"
                onClick={profileInfoMenuClick}
              >
                <p style={{fontSize:"0.9rem",fontWeight:"600",margin:"0"}}>
                  Profile Info
                </p>
              </div>
              <div
                className="tab-menu-button"
                id="accountSettingsBtn"
                onClick={accountSettingsMenuClick}
              >
                <p style={{fontSize:"0.9rem",fontWeight:"600",margin:"0"}}>
                  Account Settings
                </p>
              </div>
              <div
                className="tab-menu-button"
                id="gstAndTaxBtn"
                onClick={gstAndTaxMenuClick}
              >
                <p style={{fontSize:"0.9rem",fontWeight:"600",margin:"0"}}>
                  {currentCountry==='india'?'GST & TAX':'VAT & TAX'}
                </p>
              </div>
           </div>
         </div>
        </div> 
        <div>
        {activeTab==='profileInfo'?
          <ProfileInfo/>
         :activeTab==='accountSettings'?
         <AccountSettings profileData={companyProfileData} updateListener={updateListener} />
         :activeTab==='gstAndTax'?
         <GstAndTax profileData={companyProfileData} updateListener={updateListener}/>
         :undefined     
        }
        </div>
    </div>
  )
}
